"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processCustomerQuote = void 0;
const helpers_1 = require("../../helpers");
const getOrderById_1 = require("./getOrderById");
const updateOrder_1 = require("./updateOrder");
const updateOrderStatus_1 = require("./updateOrderStatus");
const updateVariant_1 = require("./updateVariant");
const dayjs = require("dayjs");
const updateQuote_1 = require("./updateQuote");
const processCustomerQuote = async (supabase, order_id, variant_id, action) => {
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
    // needs to set the selected variant id to the primary one (default)
    order.default_variant_id = variant_id;
    // Archive all other variants in this order
    let variants = order.variants;
    if (!variants) {
        throw new Error("No variants found");
    }
    variants = variants.filter((v) => v.id !== variant_id);
    for (const variant of variants) {
        variant.archived = true;
        await (0, updateVariant_1.updateVariant)(supabase, variant);
    }
    // get the latest quote
    const current_quote = order.quotes?.reduce((prev, current) => prev.created_at > current.created_at ? prev : current);
    if (current_quote) {
        current_quote.accepted_by = order.client_id || "";
        current_quote.accepted_date = dayjs().toISOString();
        await (0, updateQuote_1.updateQuote)(supabase, current_quote);
    }
    await (0, updateOrder_1.updateOrder)(supabase, order);
    // update the order status to QUOTE_ACCEPTED or QUOTE_REJECTED
    await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, action === "ACCEPT"
        ? helpers_1.OrderStatus.READY_FOR_WORKFLOW
        : helpers_1.OrderStatus.QUOTE_CANCELLED);
};
exports.processCustomerQuote = processCustomerQuote;
